import { useState } from "react";
import {
  Grid,
  Stack,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { GavelOutlined } from "@mui/icons-material";
import CustomSimpleAccordion from "qubCommon/Accordions/CustomSimpleAccordion";
import TextInput from "src/qubCommon/Inputs/TextInput";
import { applyAsLegalRepresentative } from "apis/controllers/applications";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";



const LegalRepresentative = ({
  rep,
  canApplyAsLegalRepresentative,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false); // ✅ loading state
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const handleOpenDialog = () => {
    if (!loading) setDialogOpen(true); // ✅ block while loading
  };

  const handleCloseDialog = () => {
    if (!loading) setDialogOpen(false); // ✅ block close during submit
  };

  const handleConfirm = async () => {
    if (loading) return; // ✅ prevent double submit

    try {
      setLoading(true);
      const res = await applyAsLegalRepresentative(id);
      if (res?.status === "success") {
        enqueueSnackbar(res?.message || 'Επιτυχής ανάληψη ως νόμιμος εκπρόσωπος', { variant: 'success' });

        setDialogOpen(false);


        // ✅ Refresh AFTER dialog unmounts
        setTimeout(() => {
          navigate(0);
        }, 120); // 100–150ms is perfect
      }
      else {
        throw new Error(res?.message || 'Αποτυχία ανάληψης ως νόμιμος εκπρόσωπος');
      }
      setDialogOpen(false);
    } catch (error) {
      enqueueSnackbar(error?.message || 'Αποτυχία ανάληψης ως νόμιμος εκπρόσωπος', { variant: 'error' });
      console.error("Apply as legal representative failed:", error);
      // εδώ μπορείς να βάλεις και snackbar / toast
    } finally {
      setLoading(false);
    }
  };

  const AccordionTitle = () => (
    <Stack direction="row" gap={1}>
      <GavelOutlined
        color="primary"
        fontSize="small"
        sx={{ marginLeft: "2px" }}
      />

      <Typography color="primary" sx={{ fontWeight: 1000 }}>
        ΝΟΜΙΜΟΣ ΕΚΠΡΟΣΩΠΟΣ
      </Typography>
      <Typography color="primary" sx={{ marginLeft: "18px", fontWeight: 500 }}>
        {rep?.lastName} {rep?.firstName}
      </Typography>
    </Stack>
  );



  return (
    <CustomSimpleAccordion title={<AccordionTitle />} content={<>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextInput
            disabled
            name="legalRepresentative.lastName"
            label="Επώνυμο"
            defaultValue={rep?.lastName}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextInput
            disabled
            name="legalRepresentative.firstName"
            label="Όνομα"
            defaultValue={rep?.firstName}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextInput
            disabled
            name="legalRepresentative.phone"
            label="Τηλέφωνο"
            defaultValue={rep?.phone}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextInput
            disabled
            name="legalRepresentative.email"
            label="E-mail"
            defaultValue={rep?.email}
          />
        </Grid>
      </Grid>

      {canApplyAsLegalRepresentative && (
        <Stack direction="row" justifyContent="flex-end" mt={2}>
          <Button variant="contained" onClick={handleOpenDialog} sx={{ textTransform: "none" }}>
            Θέλω να αναλάβω ως νόμιμος εκπρόσωπος
          </Button>
        </Stack>
      )}

      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>Ανάληψη ως νόμιμος εκπρόσωπος</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Θέλετε να αναλάβετε ως νόμιμος εκπρόσωπος για αυτήν την αίτηση;
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} >Άκυρο</Button>
          <Button onClick={handleConfirm} variant="contained" autoFocus disabled={loading}>
            Ναι, θέλω να αναλάβω
          </Button>
        </DialogActions>
      </Dialog>
    </>} />
  );
};

export default LegalRepresentative;
